import React from 'react'

const ExcelIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1142_8199)">
<path d="M3 23H21V6.709L15.29 1H3V23ZM15 2H15.2L20 6.8V7H15V2ZM4 2H14V8H20V22H4V2ZM15.891 10L12.618 14.5L15.891 19H14.655L12 15.35L9.345 19H8.11L11.383 14.5L8.109 10H9.345L12 13.65L14.655 10H15.891Z" fill="#A4A4A4"/>
</g>
<defs>
<clipPath id="clip0_1142_8199">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

  )
}

export default ExcelIcon